/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'GoalPanel.header.title': 'Objectif',
  'goal-panel.generic-error.description': 'Vérifiez votre connexion Internet et réessayez.',
  'goal-panel.generic-error.title': 'Une erreur est survenue',
  'goal-panel.goal-panel-expand-field-button.show-less-collapsed-label': 'Afficher plus de champs',
  'goal-panel.goal-panel-expand-field-button.show-more-collapsed-label': 'Afficher moins',
  'goal-panel.goal-panel-tabs.about-tab-title': 'À propos',
  'goal-panel.goal-panel-tabs.jira-align-title': 'Jira Align',
  'goal-panel.goal-panel-tabs.jira-title': 'Jira',
  'goal-panel.goal-panel-tabs.projects-title': 'Projets',
  'goal-panel.goal-panel-tabs.updates-tab-title': 'Mises à jour',
  'goal-panel.goal-title.edit-button-label': "Modifier le titre de l'objectif",
  'goal-panel.goal-title.update-error-description': 'Impossible de mettre à jour le contenu de {goalName}',
  'goal-panel.goal-title.update-error-title': 'Une erreur est survenue',
  'goal-panel.goal-title.validation-message': 'Spécifiez un titre pour votre objectif',
};
